<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-package-variant"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('packaging_products') }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @keydown.enter="getDataFromApi"
          @blur="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.type="{ item }">
          <v-chip
            :color="'green'"
            text-color="white"
          >
            {{ item.type }}
          </v-chip>
        </template>
        <template v-slot:item.dimensions="{ item }">
          <template>
            {{ item.height }}<v-icon size="14">
              mdi-close
            </v-icon>{{ item.width }}<v-icon size="14">
              mdi-close
            </v-icon>{{ item.length }}
          </template>
        </template>
        <template v-slot:item.price="{ item }">
          <v-tooltip
            :key="item.id"
            top
          >
            <template v-slot:activator="{ on }">
              <v-chip
                small
                v-on="on"
              >
                {{ item.price.toFixed(2) }} ,-
              </v-chip>
            </template>
            <template>
              <div>Kostpris for én palle: {{ item.price.toFixed(2) }} kr. ex. moms</div>
              <div>Platinum Plus (5%): {{ (item.price*1.05).toFixed(2) }} kr. ex. moms</div>
              <div>Platinum (10%): {{ (item.price*1.1).toFixed(2) }} kr. ex. moms</div>
              <div>Guld (15%): {{ (item.price*1.15).toFixed(2) }} kr. ex. moms</div>
              <div>Sølv (20%): {{ (item.price*1.2).toFixed(2) }} kr. ex. moms</div>
            </template>
          </v-tooltip>
        </template>
        <template v-slot:item.created_at="{item}">
          {{ convertUTCToLocal(item.created_at) }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="() => {useComputedProductCode = false; editItem(item)}"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              medium
              color="red"
              class="mr-5"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
      <v-col>
        <v-row>
          <v-btn
            color="green"
            class="ml-auto mt-5"
            @click="editItem({id: null})"
          >
            <v-icon class="mr-3">
              mdi-plus
            </v-icon>
            {{ $t('new') }}
          </v-btn>
        </v-row>
      </v-col>
    </base-material-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      @click:outside="close()"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('packaging_product') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    :rules="rules"

                    :label="$t('name')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="editedItem.description"
                    :rules="rules"

                    :label="$t('description')"
                  />
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-text-field
                    v-model="editedItem.height"
                    :rules="rules"
                    type="number"
                    :label="$t('height')"
                    suffix="cm"
                  />
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-text-field
                    v-model="editedItem.width"
                    :rules="rules"
                    type="number"

                    :label="$t('width')"
                    suffix="cm"
                  />
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-text-field
                    v-model="editedItem.length"
                    :rules="rules"
                    type="number"

                    :label="$t('length')"
                    suffix="cm"
                  />
                </v-col>
                <v-col
                  cols="3"
                >
                  <v-text-field
                    v-model="editedItem.type"
                    :rules="rules"
                    :label="$t('type')"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-show="useComputedProductCode"
                    :value="productCode"
                    :label="$t('internal_product_code')"
                    readonly
                    append-outer-icon="lock"
                    @click:append-outer="useComputedProductCode = !useComputedProductCode"
                  />
                  <v-text-field
                    v-show="!useComputedProductCode"
                    v-model="editedItem.internal_product_code"
                    :rules="rules"
                    :label="$t('internal_product_code')"
                    append-outer-icon="lock_open"
                    @click:append-outer="useComputedProductCode = !useComputedProductCode"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="editedItem.supplier_product_code"
                    :rules="rules"
                    :label="$t('supplier_product_code')"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="editedItem.price"
                    :rules="rules"
                    :label="$t('cost_price')"
                    suffix="DKK"
                  />
                </v-col>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="editedItem.amount"
                    :rules="rules"
                    :label="$t('count')"
                    suffix="stk"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'
  import { ROLES } from '../../../utils/constants'

  export default {
    mixins: [List],
    data () {
      return {
        CRUDL: {
          C: ROLES.ECONOMY,
          U: ROLES.ECONOMY,
          D: ROLES.ECONOMY,
        },
        endpoint: 'packaging-products',
        name: 'packaging_product',
        headers: [
          {
            sortable: false,
            text: this.$t('type'),
            value: 'type',
          },
          {
            sortable: false,
            text: this.$t('name'),
            value: 'name',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('description'),
            value: 'description',
          },
          {
            sortable: false,
            text: this.$t('dimensions'),
            value: 'dimensions',
          },

          {
            sortable: false,
            text: this.$t('internal_product_code'),
            value: 'internal_product_code',
          },
          {
            sortable: false,
            text: this.$t('supplier_product_code'),
            value: 'supplier_product_code',
          },
          {
            sortable: false,
            text: this.$t('count'),
            value: 'amount',
          },
          {
            sortable: false,
            text: this.$t('cost_price'),
            value: 'price',
          },
          {
            sortable: false,
            text: this.$t('created'),
            value: 'created_at',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
        editedItem: {
          name: '',
          description: '',
          height: '',
          length: '',
          width: '',
          internal_product_code: '',
          supplier_product_code: '',
          price: '',
          amount: '',
          type: '',
        },
        defaultItem: {
          name: '',
          description: '',
          height: '',
          length: '',
          width: '',
          internal_product_code: '',
          supplier_product_code: '',
          price: '',
          amount: '',
          type: '',
        },
        useComputedProductCode: true,
      }
    },
    computed: {
      productCode: function () {
        return `${this.editedItem.length && `${this.editedItem.length}x`}${this.editedItem.width && `${this.editedItem.width}x`}${this.editedItem.height.split('/')[0] || ''}`
      },
    },
    watch: {
      dialog: function () {
        if (!this.dialog) { this.useComputedProductCode = true }
      },
    },
    methods: {
      save () {
        if (!this.editedItem.id && !this.canCreate()) { return }
        if (this.editedItem.id && !this.canUpdate()) { return }

        let item = { ...this.editedItem }

        if (this.useComputedProductCode) { item = { ...this.editedItem, internal_product_code: this.productCode } }
        let url = this.endpoint

        if (this.editedItem.id) { url += `/${this.editedItem.id}` }

        this.$post(url, item, { useDev: this.useDev }).then(() => {
          this.getDataFromApi()
          this.$toast(`${this.$t(this.name)} ${this.$t('saved_correctly')}`)

          this.close()
        })
      },
    },
  }
</script>
